import { Commitment } from "@solana/web3.js";

export const COMMITMENT: Commitment = "confirmed";
